(function () {
    var sectionSelector = '.npbp-bundle-sticky-bar';
    var itemSelector = '.npbp-bundle-sticky-bar__item';
    var targetCache = new WeakMap();
    var heightCache = new WeakMap();

    function escapeAttr(value) {
        if (window.CSS && typeof CSS.escape === 'function') {
            return CSS.escape(value);
        }
        return String(value).replace(/"/g, '\\"');
    }

    function findTarget(section, targetId) {
        if (!targetId) return null;

        var cache = targetCache.get(section);
        if (!cache) {
            cache = Object.create(null);
            targetCache.set(section, cache);
        }

        if (cache[targetId] === undefined) {
            cache[targetId] = document.getElementById(targetId)
                || document.querySelector('[data-id="' + escapeAttr(targetId) + '"]')
                || document.querySelector('[data-tab-id="' + escapeAttr(targetId) + '"]');
        }

        return cache[targetId];
    }

    function getStickyOffset(section) {
        var cached = heightCache.get(section);
        if (typeof cached === 'number') return cached;
        var height = section.offsetHeight;
        heightCache.set(section, height);
        return height;
    }

    function invalidateHeight(section) {
        heightCache.delete(section);
    }

    function setActive(section, targetId) {
        section.querySelectorAll(itemSelector).forEach(function (item) {
            item.classList.toggle('is-active', item.getAttribute('data-target') === targetId);
        });
    }

    function updateActiveState(section) {
        var items = section.querySelectorAll(itemSelector);
        var offset = window.pageYOffset + getStickyOffset(section) + 24;
        var activeTargetId = '';

        items.forEach(function (item) {
            var targetId = item.getAttribute('data-target');
            var target = findTarget(section, targetId);
            if (!target) return;
            var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
            if (targetTop <= offset) {
                activeTargetId = targetId;
            }
        });

        if (!activeTargetId && items.length > 0) {
            activeTargetId = items[0].getAttribute('data-target');
        }

        if (activeTargetId && section.dataset.activeTargetId !== activeTargetId) {
            section.dataset.activeTargetId = activeTargetId;
            setActive(section, activeTargetId);
        }
    }

    function bindSection(section) {
        if (section.dataset.npbpStickyBarBound === 'true') {
            updateActiveState(section);
            return;
        }

        section.dataset.npbpStickyBarBound = 'true';

        var abortController = new AbortController();
        section._npbpStickyBarAbort = abortController;
        var signal = abortController.signal;

        section.querySelectorAll(itemSelector).forEach(function (item) {
            item.addEventListener('click', function (event) {
                var targetId = item.getAttribute('data-target');
                var target = findTarget(section, targetId);
                if (!target) return;

                event.preventDefault();
                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset(section),
                    behavior: 'smooth'
                });
                section.dataset.activeTargetId = targetId;
                setActive(section, targetId);
            }, { signal: signal });
        });

        updateActiveState(section);
    }

    function init(root) {
        var scope = root || document;
        var sections = scope.matches && scope.matches(sectionSelector)
            ? [scope]
            : scope.querySelectorAll(sectionSelector);

        sections.forEach(function (section) {
            bindSection(section);
        });
    }

    function destroy(root) {
        var scope = root || document;
        var sections = scope.matches && scope.matches(sectionSelector)
            ? [scope]
            : scope.querySelectorAll(sectionSelector);

        sections.forEach(function (section) {
            if (section._npbpStickyBarAbort) {
                section._npbpStickyBarAbort.abort();
                section._npbpStickyBarAbort = null;
            }
            targetCache.delete(section);
            heightCache.delete(section);
            delete section.dataset.npbpStickyBarBound;
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        init(document);

        var offsetTops = new WeakMap();
        var ticking = false;

        function getSections() {
            return document.querySelectorAll(sectionSelector);
        }

        getSections().forEach(function (section) {
            offsetTops.set(section, section.offsetTop);
        });

        function onScroll() {
            getSections().forEach(function (section) {
                var placeholder = section.nextElementSibling &&
                    section.nextElementSibling.classList.contains('npbp-bundle-sticky-bar-placeholder')
                    ? section.nextElementSibling
                    : document.querySelector('.npbp-bundle-sticky-bar-placeholder');
                var stickyBarOffsetTop = offsetTops.get(section) || section.offsetTop;

                if (window.pageYOffset >= stickyBarOffsetTop) {
                    section.classList.add('is-fixed');
                    if (placeholder) placeholder.style.height = getStickyOffset(section) + 'px';
                } else {
                    section.classList.remove('is-fixed');
                    if (placeholder) placeholder.style.height = 0;
                    invalidateHeight(section);
                    offsetTops.set(section, section.offsetTop);
                }
                updateActiveState(section);
            });
        }

        window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
                onScroll();
                ticking = false;
            });
        }, { passive: true });

        window.addEventListener('resize', function () {
            document.querySelectorAll(sectionSelector).forEach(function (section) {
                if (!section.classList.contains('is-fixed')) {
                    offsetTops.set(section, section.offsetTop);
                }
                invalidateHeight(section);
                updateActiveState(section);
            });
        }, { passive: true });
    });

    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
        destroy(event.target);
    });
})();
